import { env } from '../config/env';

declare const __BUILD_HASH__: string;

// Mapeamento estático de capas de módulo por id.
// Projeto novo (neurodidatica): sem capas locais ainda — as capas devem ser
// enviadas pelo admin (servidas pelo backend via coverUpdatedAt) ou adicionadas
// aqui apontando para arquivos em /assets/modules/. Enquanto vazio, todos os
// módulos usam o placeholder genérico.
const MODULE_IMAGES: Record<number, string> = {};

const DEFAULT_MODULE_IMAGE = '/assets/placeholder.svg';
const CACHE_BUSTER = typeof __BUILD_HASH__ === 'string' ? __BUILD_HASH__ : '';

/**
 * Resolve a URL da capa de um módulo.
 * - Se o módulo tem capa gerenciada no backend (coverUpdatedAt), usa o endpoint
 *   público GET /modules/:id/cover (com cache-bust pelo timestamp da capa).
 * - Caso contrário, cai no mapeamento estático do front / imagem padrão.
 */
export function getModuleImageSrc(
  module: { id: number; coverUpdatedAt?: string | null },
): string {
  if (module.coverUpdatedAt) {
    return `${env.apiBaseUrl}/modules/${module.id}/cover?v=${encodeURIComponent(module.coverUpdatedAt)}`;
  }
  const src = MODULE_IMAGES[module.id] ?? DEFAULT_MODULE_IMAGE;
  return CACHE_BUSTER ? `${src}?v=${CACHE_BUSTER}` : src;
}
